import React from "react";

const OtpLoanOffers = ({ loanType }) => {
  const formatLoanType = (type) => {
    if (type === "nri") return "NRI";
    return type ? type.charAt(0).toUpperCase() + type.slice(1) : "";
  };
  
  return (
    <div className="special-offers-container">
      <div className="special-offers-header">
        {formatLoanType(loanType)} Loan
      </div>

      {loanType === "home" && (
        <div class="loan-card" data-loantype="homeloan">
          <div className="special-offer-main">
            <p>“Get the Keys to Your Dream Home — Faster Than Ever."</p>
            <h3>Dream Home Loan up to ₹ 10 Crore*</h3>
          </div>

          <div className="special-offer-pair">
            <div className="special-offer-box">
              <p>Interest Rate Starts @</p>
              <h4>7.35%*</h4>
            </div>
            <div className="special-offer-box">
              <p>Tenure up to</p>
              <h4>30*</h4>
              <p>Years</p>
            </div>
            <div className="special-offer-box">
              <p>Offers From</p>
              <h4>50+</h4>
              <p>Lenders</p>
            </div>
            <div className="special-offer-box">
              <p>Rewards</p>
              <h4>₹10000*</h4>
            </div>
          </div>
          <div className="special-offer-main mt-2">
            <p>
              “Transfer Your Existing Home Loan @ Lowest interest Rate - Save
              More-Pay Less.”
            </p>
            <h6 className="highlight-rate">
              “Are you NRI - not in India? Apply From Anywhere.”
            </h6>
          </div>
        </div>
      )}

      {loanType === "personal" && (
        <div class="loan-card" data-loantype="personalloan">
          <div className="special-offer-main">
            <h3>"Fin-tastic Personal Loan up to <br />₹50 LAKHS*."</h3>
          </div>

          <div className="special-offer-pair">
            <div className="special-offer-box">
              <p>EMI</p>
              <h4>1673*</h4>
              <p>P/M</p>
            </div>

            <div className="special-offer-box">
              <p>Tenure up to</p>
              <h4>84*</h4>
              <p>Months</p>
            </div>

            <div className="special-offer-box">
              <p>Interest Starts @</p>
              <h4>10.25%*</h4>
            </div>

            <div className="special-offer-box">
              <p>Approved in</p>
              <h4>5 min*</h4>
            </div>

            <div className="special-offer-box">
              <p>Pre-Closure Charge</p>
              <h4>0%*</h4>
            </div>

            <div className="special-offer-box">
              <br />
              <p>Rewards</p>
              <h4>₹10000*</h4>
            </div>
          </div>

          <div className="special-offer-main mt-2">
            <p>“Transfer Your Existing Personal Loan - <br />Save More-Pay Less.”</p>
          </div>
        </div>
      )}

      {loanType === "business" && (
        <div class="loan-card" data-loantype="businessloan">
          <div className="special-offer-main">
            <p>
              “Business Loans Made Easy — Fuel Your Growth with the Right
              Funding.”
            </p>
            <h3>Collateral Free up-to ₹ 1 Crore</h3>
          </div>

          <div className="special-offer-pair">
            <div className="special-offer-box">
              <p>Interest Starts @</p>
              <h4 className="offers-highlight">15%*</h4>
            </div>

            <div className="special-offer-box">
              <p>Tenure up to</p>
              <h4 className="offers-highlight">48*</h4>
              <p>Months</p>
            </div>

            <div className="special-offer-box">
              <p>EMI Option</p>
              <h4 className="offers-highlight">Easy EMI</h4>
            </div>

            <div className="special-offer-box">
              <p>Rewards</p>
              <h4 className="offers-highlight">₹10000*</h4>
            </div>
          </div>

          <div className="special-offer-main mt-2">
            <p>“Transfer Your Existing OD/CC Loan - <br />Save More-Pay Less.”</p>
          </div>
        </div>
      )}

      {loanType === "mortgage" && (
        <div class="loan-card" data-loantype="mortgageloan">
          <div className="special-offer-main">
            <p>
              “Turn Your Property into Opportunity — Let Its Value Work for Your
              Dreams."
            </p>
            <h3> Mortgage Loan up to ₹ 10 Crore*</h3>
          </div>

          <div className="special-offer-pair">
            <div className="special-offer-box">
              <p>Property Value</p>
              <h4>95%*</h4>
            </div>

            <div className="special-offer-box">
              <p>Tenure</p>
              <h4>15*</h4>
              <p>Years</p>
            </div>

            <div className="special-offer-box">
              <p>Interest Starts @</p>
              <h4>9.25%*</h4>
            </div>

            <div className="special-offer-box">
              <p>Rewards</p>
              <h4>₹10000*</h4>
            </div>
          </div>

          <div className="special-offer-main mt-2">
            <p>
              “Transfer Your Existing Property Loan @ Lowest interest Rate -
              Save More-Pay Less.”
            </p>
            <h6 className="highlight-rate">
              “NRI - Customers not in India? Apply From Anywhere.”
            </h6>
          </div>
        </div>
      )}

      {loanType === "nri" && (
        <div class="loan-card" data-loantype="nriloan">
          <div className="special-offer-main">
            <h3>FIN- JET Personal Loan up to <br />₹15 LAKHS*</h3>
          </div>

          <div className="special-offer-pair">
            <div className="special-offer-box">
              <p>Interest Starts @</p>
              <h4 className="offers-highlight">12%*</h4>
            </div>

            <div className="special-offer-box">
              <p>Tenure up to</p>
              <h4 className="offers-highlight">36*</h4>
              <p>Months</p>
            </div>

            <div className="special-offer-box">
              <p>EMI Option</p>
              <h4 className="offers-highlight">Easy EMI</h4>
            </div>

            <div className="special-offer-box">
              <p>Rewards</p>
              <h4 className="offers-highlight">₹3000*</h4>
            </div>
          </div>

          <div className="special-offer-main mt-2">
            <p>“Transfer Your Existing Personal Loan - <br />Save More-Pay Less.”</p>
          </div>
        </div>
      )}

      {loanType === "doctor" && (
        <div class="loan-card" data-loantype="doctorloan">
          <div className="special-offer-main">
            <p>Doctor? Approved in Seconds.</p>
            <h3> Doctor Loan up to ₹ 1 Crore*</h3>
          </div>

          <div className="special-offer-pair">
            <div className="special-offer-box">
              <p>Interest Starts @</p>
              <h4 className="offers-highlight">10.25%*</h4>
            </div>

            <div className="special-offer-box">
              <p>Tenure up to</p>
              <h4 className="offers-highlight">84*</h4>
              <p>Months</p>
            </div>

            <div className="special-offer-box">
              <p>Offers From</p>
              <h4 className="offers-highlight">20+</h4>
              <p>Lenders</p>
            </div>

            <div className="special-offer-box">
              <p>Rewards</p>
              <h4 className="offers-highlight">₹10000*</h4>
            </div>
          </div>

          <div className="special-offer-main mt-2">
            <p>“Transfer Your Existing Personal Loan - Save More-Pay Less.”</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtpLoanOffers;
